import { checkInDetailQueryOptions } from '@/api/queries/activity';
import { QueryState } from '@/components/layout/query-state';
import { ScreenHeader } from '@/components/layout/screen-header';
import { PageTitle } from '@/components/seo/page-title';
import { ActivityCard } from '@/features/activity/components/activity-card';
import { useLikeCheckIn } from '@/features/activity/hooks/use-like-check-in';
import { useQuery } from '@tanstack/react-query';
import { useLocalSearchParams } from 'expo-router';
import { ScrollView, View } from 'react-native';

export default function CheckInDetailScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const { toggleLike } = useLikeCheckIn();

  const {
    data: feedItem,
    isLoading,
    error,
    refetch,
  } = useQuery(checkInDetailQueryOptions(id || ''));

  return (
    <QueryState
      isLoading={isLoading}
      error={error}
      onRetry={() => refetch()}
      loadingMessage="Loading check-in..."
      fullScreen={false}
    >
      {feedItem && (
        <View className="flex-1">
          <PageTitle title={feedItem.menuItem.name || 'Check-in'} />
          <ScreenHeader title="Check-in" showBackButton />

          <ScrollView showsVerticalScrollIndicator={false}>
            <View className="px-4 pt-4 pb-8">
              <ActivityCard item={feedItem} onLike={toggleLike} />
            </View>
          </ScrollView>
        </View>
      )}
    </QueryState>
  );
}
